import { QueryClient } from "react-query";
import graphqlApiHandler from "../utils/graphql-api-handler";

const queryClient = new QueryClient();

export function queryProfile(variables) {

  return queryClient.fetchQuery(['profile'], graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`, 
    `query ($userId: String!) {
      userProfile(userId: $userId) {
          id
          userId
          stars
          coins
          level
          starsPrevLevel
          starsNextLevel
          playData {
            daysPlayed
            timeSpent
            dailyActivityMap
          }
          rewardsHistory {
            previousDayBasedQuestBadgeAchievedOrdering
            previousTimeBasedQuestBadgeAchievedOrdering
            previousWeeklyQuestBadgeAchievedOrdering
            previousWeeklyQuestBadgeAchievedDateTimeUTC
            daysCoinsWereAwarded
          }
          weeklyGoal {
             days
             duration
          }
      }
    }`,
    variables
  ));
}

export function queryBadges() {

  return queryClient.fetchQuery(['queryList'], graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
    `{
      badges {
          url
          name
          type
          ordering
          milestone
          threshold
          code
          version
        }
      }
    `));
}

export function queryUserBadge(variables) {

  return queryClient.fetchQuery(['userBadge'], graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
    `query ($userId: String!) {
      userBadges(userId: $userId) {
        userId
        badge {
          url
          name
          type
          ordering
          milestone
          threshold
          code
          version
        }
        state
        weeklyGoalWhenBadgeAwarded {
          days
          duration
        }
        achievementDateTimeUTC
      }
    }
    `,
    variables));
}

export function updateUserGoal(variables) {
  return queryClient.fetchQuery(['updateUserGoal'], graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
    `mutation ($userProfileInput: UserProfileInput!) {
      editUserProfile(userProfileInput: $userProfileInput) {
        id
        userId
        stars
        coins
        level
        starsPrevLevel
        starsNextLevel
        weeklyGoal {
          days
          duration
        }
      }
    }
    `,
    variables));
}

export function updateSeenBadges(variables) {
  return queryClient.fetchQuery(['updateUserBadge'], graphqlApiHandler(`${BASE_API_GATEWAY_URL}/rewards-service/graphql`,
    `mutation (
      $userBadgeInputList: UserBadgeInputList!
      ) {
      editUserBadgeState(userBadgeInputList: $userBadgeInputList) {
        userId
        badge {
          code
        }
        state
      }
    }
    `,
    variables));
}